import { useState } from "react";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";

const InputPassword = ({ label, name, set, val, error }) => {
  const [show, setShow] = useState(false);
  const errMsg = error?.find((err) => err.param === name)?.msg;

  return (
    <div className="mb-4">
      <label htmlFor={name} className="block mb-2 text-sm font-sans text-gray-700 font-bold">
        {label}
      </label>
      <div className="relative">
        <input
          type={show ? "text" : "password"}
          name={name}
          id={name}
          value={val}
          onChange={(e) => set(e.target.value)}
          className={`bg-gray-50 ring-1 border-0 text-gray-900 sm:text-sm rounded-lg block w-full p-2 pr-10 font-sans ${
            errMsg ? "ring-red-500 focus:ring-red-500" : "ring-gray-300 focus:ring-blue-600"
          }`}
          placeholder={label}
          required
        />
        <span
          className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-gray-600"
          onClick={() => setShow(!show)}
        >
          {show ? <FaRegEye /> : <FaRegEyeSlash />}
        </span>
      </div>
      {errMsg && <p className="mt-1 text-sm text-red-600 font-sans">{errMsg}</p>}
    </div>
  );
};

export default InputPassword;